import React from "react";
import { Button, ButtonGroup, Glyphicon, ListGroupItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useLocation } from "react-router-dom";

const WidgetsListItem = (
    {
        widget,
        onEdit,
        onDelete,
    }
) => {
    const {pathname}= useLocation();

    function handleConfirmRemove(widget) {
        const allow = confirm(`Удалить виджет ${widget.name}?`);

        allow && onDelete(widget.widgetKey);
    }

    return (
        <ListGroupItem
            style={{
                display: 'flex',
                justifyContent: 'space-between',
            }}
        >
            <h4>{widget.name || 'Новый виджет'}</h4>
            <ButtonGroup>
                <LinkContainer to={`${pathname}/edit/${widget.widgetKey}`}>
                    <Button onClick={() => onEdit(widget)}>
                        <Glyphicon glyph="pencil" />
                    </Button>
                </LinkContainer>
                <Button onClick={() => handleConfirmRemove(widget)}>
                    <Glyphicon glyph="trash" />
                </Button>
            </ButtonGroup>
        </ListGroupItem>
    );
};

export default WidgetsListItem;
